module.exports = __webpack_public_path__ + "img/unither-logo-white.eb7a6ca2.svg";